import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Componentes Globales
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AnnouncementModal from './components/AnnouncementModal'; 

// Páginas
import Home from './components/Home';
import Login from './components/Login';
import PanelControl from './components/PanelControl';
import Galeria from './components/Galeria';
import DeclaracionFe from './components/DeclaracionFe';
import HistoriaCorporacion from './components/HistoriaCorporacion';
import HistoriaIglesia from './components/HistoriaIglesia';
import Recuerdo from './components/DelRecuerdo';
import SecretEventsAdmin from './components/SecretEventsAdmin';

import './App.css'; 

// --- COMPONENTE ENVOLTORIO PARA LÓGICA DE VISIBILIDAD ---
const MainLayout = ({ children, user, onLogout, setIsModalOpen }) => {
    const location = useLocation();
    
    // Definimos las rutas donde NO queremos Navbar ni Footer
    const isPanelOrLogin = location.pathname.startsWith('/panel') || location.pathname.startsWith('/eventos-secreto-admin');

    return (
        <>
            {/* Si NO es panel o login, mostramos Navbar */}
            {!isPanelOrLogin && (
                <Navbar 
                    user={user} 
                    onLogout={onLogout} 
                    setIsModalOpen={setIsModalOpen} 
                />
            )}

            {children}

            {/* Si NO es panel o login, mostramos Footer */}
            {!isPanelOrLogin && <Footer />}
        </>
    );
};

const HashListener = ({ setIsModalOpen }) => {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/' && location.hash === '#avisos') {
            setIsModalOpen(true);
        }
    }, [location, setIsModalOpen]);

    return null;
};

function App() {
    const [user, setUser] = useState(() => {
        const savedUser = localStorage.getItem('user_session');
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('user_session') !== null;
    });

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleLogin = (userData) => {
        setIsAuthenticated(true);
        setUser(userData);
        localStorage.setItem('user_session', JSON.stringify(userData));
    };

    const handleLogout = () => {
        setIsAuthenticated(false);
        setUser(null);
        localStorage.removeItem('user_session');
        window.location.href = '/'; 
    };

    const ProtectedRoute = ({ children }) => {
        if (!isAuthenticated) return <Navigate to="/panel/login" replace />; 
        return children;
    };

    return (
        <Router>
            <MainLayout user={user} onLogout={handleLogout} setIsModalOpen={setIsModalOpen}>
                
                <AnnouncementModal 
                    isOpen={isModalOpen} 
                    onClose={() => setIsModalOpen(false)} 
                />

                <HashListener setIsModalOpen={setIsModalOpen} />

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/del-recuerdo" element={<Recuerdo />} />
                    <Route path="/galeria" element={<Galeria />} />
                    <Route path="/declaracion-fe" element={<DeclaracionFe />} /> 
                    <Route path="/historia-corporacion" element={<HistoriaCorporacion />} />
                    <Route path="/historia-iglesia" element={<HistoriaIglesia />} />
                    <Route path="/eventos-secreto-admin" element={<SecretEventsAdmin />} />
                    
                    <Route 
                        path="/panel/login" 
                        element={isAuthenticated ? <Navigate to="/panel" replace /> : <Login onLoginSuccess={handleLogin} />} 
                    />
                    
                    <Route 
                        path="/panel/*" 
                        element={
                            <ProtectedRoute>
                                <PanelControl user={user} onLogout={handleLogout} />
                            </ProtectedRoute>
                        } 
                    />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>

            </MainLayout>
        </Router>
    );
}

export default App;